import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {FusionAuthGuard} from "../../../shared/guard";
import {ResultEntryComponent} from "./pages";
import {ResultEntryAccessGuard} from "./guards/result-entry-access.guard";

const routes: Routes = [ {
  path: '',
  component: ResultEntryComponent,
  canActivate: [FusionAuthGuard, ResultEntryAccessGuard],
  data: { roles: ['Superuser', 'Client Admin'] },
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResultEntryRoutingModule { }
